import './modal-without-users.scss';
import Button from '../../components/button/button';
import WithoutUsers from '../../assets/without-users.png';
import ModalTemplate from '../modal-template/modal-template';
import TranslateService from '../../services/translate-service';

export default function ModalWithoutUsers(props) {

    return (
        <ModalTemplate isOpen={props.isOpen} className="modal-without-users">
            <div className='text-center'>
                <img src={WithoutUsers} alt='' className='m-auto' />

                <h1 className='heading-h3 mt-[16px]'>{TranslateService.get('modal.withoutusers.title')}</h1>

                <p className='mt-[16px] mb-[24px]'>
                {TranslateService.get('modal.withoutusers.description')}
                </p>

                <Button onClick={props.onClose}>
                {TranslateService.get('modal.withoutusers.btn')}
                </Button>

            </div>
        </ModalTemplate>
    )
}